export default "__VITE_ASSET__D7IiJPjU__"